// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeInModal 0.2s ease-out forwards;
}

.modal-box {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 420px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

[data-theme="dark"] .modal-box {
  background: #1e293b;
  border: 1px solid #334155;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
}

.modal-icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0 16px;
}

.modal-icon {
  font-size: 48px;
  line-height: 1;
}

.modal-alert-content {
  padding: 0 24px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.modal-title {
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
}

[data-theme="dark"] .modal-title {
  color: #f8fafc;
}

.modal-message {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #475569;
}

[data-theme="dark"] .modal-message {
  color: #cbd5e1;
}

.modal-detail {
  margin: 12px 0 0;
  font-size: 13px;
  color: #64748b;
  background: #f1f5f9;
  padding: 8px 12px;
  border-radius: 8px;
  text-align: left;
}

[data-theme="dark"] .modal-detail {
  color: #94a3b8;
  background: #0f172a;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 20px 24px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

[data-theme="dark"] .modal-actions {
  background: #0f172a;
  border-top-color: #334155;
}

.modal-btn {
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
  min-width: 100px;
}

.modal-btn-cancel {
  background: white;
  color: #475569;
  border: 1px solid #cbd5e1;
}

[data-theme="dark"] .modal-btn-cancel {
  background: transparent;
  color: #cbd5e1;
  border-color: #475569;
}

.modal-btn-cancel:hover {
  background: #f1f5f9;
}

[data-theme="dark"] .modal-btn-cancel:hover {
  background: #1e293b;
}

.modal-btn-confirm {
  background: #0ea5e9;
  color: white;
}

.modal-btn-confirm:hover {
  background: #0284c7;
}

.modal-btn-close {
  background: #0ea5e9;
  color: white;
  width: 100%;
}

.modal-btn-close.error {
  background: #ef4444;
}

.modal-btn-close.error:hover {
  background: #dc2626;
}

.modal-btn-close.warning, .modal-btn-close.alert {
  background: #f59e0b;
}

.modal-btn-close.warning:hover, .modal-btn-close.alert:hover {
  background: #d97706;
}

.modal-btn-close.success {
  background: #10b981;
}

.modal-btn-close.success:hover {
  background: #059669;
}

@keyframes fadeInModal {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUpModal {
  from { opacity: 0; transform: translateY(20px) scale(0.95); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* =========================================
   RESPONSIVE DESIGN (Tablets y Móviles)
   ========================================= */
@media (max-width: 480px) {
  .modal-actions {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }
  
  .modal-btn {
    width: 100%;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;;8CAE8C;AAC9C;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeInModal 0.2s ease-out forwards;\n}\n\n.modal-box {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  width: 90%;\n  max-width: 420px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  animation: slideUpModal 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n[data-theme=\"dark\"] .modal-box {\n  background: #1e293b;\n  border: 1px solid #334155;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);\n}\n\n.modal-icon-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 0 16px;\n}\n\n.modal-icon {\n  font-size: 48px;\n  line-height: 1;\n}\n\n.modal-alert-content {\n  padding: 0 24px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-title {\n  margin: 0 0 12px;\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n[data-theme=\"dark\"] .modal-title {\n  color: #f8fafc;\n}\n\n.modal-message {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #475569;\n}\n\n[data-theme=\"dark\"] .modal-message {\n  color: #cbd5e1;\n}\n\n.modal-detail {\n  margin: 12px 0 0;\n  font-size: 13px;\n  color: #64748b;\n  background: #f1f5f9;\n  padding: 8px 12px;\n  border-radius: 8px;\n  text-align: left;\n}\n\n[data-theme=\"dark\"] .modal-detail {\n  color: #94a3b8;\n  background: #0f172a;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px 24px;\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n}\n\n[data-theme=\"dark\"] .modal-actions {\n  background: #0f172a;\n  border-top-color: #334155;\n}\n\n.modal-btn {\n  padding: 10px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  border: none;\n  transition: all 0.2s;\n  min-width: 100px;\n}\n\n.modal-btn-cancel {\n  background: white;\n  color: #475569;\n  border: 1px solid #cbd5e1;\n}\n\n[data-theme=\"dark\"] .modal-btn-cancel {\n  background: transparent;\n  color: #cbd5e1;\n  border-color: #475569;\n}\n\n.modal-btn-cancel:hover {\n  background: #f1f5f9;\n}\n\n[data-theme=\"dark\"] .modal-btn-cancel:hover {\n  background: #1e293b;\n}\n\n.modal-btn-confirm {\n  background: #0ea5e9;\n  color: white;\n}\n\n.modal-btn-confirm:hover {\n  background: #0284c7;\n}\n\n.modal-btn-close {\n  background: #0ea5e9;\n  color: white;\n  width: 100%;\n}\n\n.modal-btn-close.error {\n  background: #ef4444;\n}\n\n.modal-btn-close.error:hover {\n  background: #dc2626;\n}\n\n.modal-btn-close.warning, .modal-btn-close.alert {\n  background: #f59e0b;\n}\n\n.modal-btn-close.warning:hover, .modal-btn-close.alert:hover {\n  background: #d97706;\n}\n\n.modal-btn-close.success {\n  background: #10b981;\n}\n\n.modal-btn-close.success:hover {\n  background: #059669;\n}\n\n@keyframes fadeInModal {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUpModal {\n  from { opacity: 0; transform: translateY(20px) scale(0.95); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* =========================================\n   RESPONSIVE DESIGN (Tablets y Móviles)\n   ========================================= */\n@media (max-width: 480px) {\n  .modal-actions {\n    flex-direction: column;\n    gap: 12px;\n    padding: 16px;\n  }\n  \n  .modal-btn {\n    width: 100%;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
